import { colorsPalettes, mixins } from "@similarweb/styles";
import styled from "styled-components";

export const CUSTOM_MODAL_STYLES = {
    content: { padding: 0, width: 550, minHeight: 240 },
};

export const StyledLabel = styled.span`
    ${mixins.setFontVariant("body1", colorsPalettes.carbon["400"])};
    display: inline-block;
    line-height: 20px;
    margin-bottom: 16px;
`;

export const StyledNameInputContainer = styled.div`
    margin-top: 36px;
`;
